import appConfig from "@/app.config";

const schema = {
  tabs: [
    // Description
    {
      title: 'Practice Team',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Description",
      side_panel: {},
      form: {
        description: {
          type: 'ckeditor',
          label: 'Page Description',
          placeholder: '',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
        related_information: {
          type: 'checkbox',
          label: 'Related Information',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [
            {
              name: 'Practice Team',
              value: true
            },
            {
              name: 'Practice Location',
              value: false
            },
            {
              name: 'GP & Nurse Availability',
              value: true
            },
            {
              name: 'When we are Closed',
              value: false
            },
            {
              name: 'Contact Us ',
              value: false
            },
          ]
        },
      }
    },
    // Group
    {
      title: 'Practice Team',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Groups",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Group',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Enter Name',
        placeholder: 'Enter Name',
        required: true,
        info: true,
        character_count: 0
        },
      },
      action_buttons: {
        add_new_button: true,
        delete_button: true,
        active_button: true,
      },
      add_new_modal: {
        name: {
          type: 'text',
          label: 'Name',
          placeholder: '',
          required: true,
          info: false,
          character_count: 0
        },
      },
      side_panel: {
        groups: {
          type: 'list',
          label: 'Groups',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          draggable: true
        },
      },
      form: {
        name: {
          type: 'text',
          label: 'Group Title',
          placeholder: '',
          required: true,
          info: true,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        role: {
          type: 'subgroup',
          label: 'Sub-groups',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: ''
        },
      },
    },
    // Team
    {
      title: 'Practice Team',
      meta: [{ name: "description", content: appConfig.description }],
      name: "Team",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Member',
      formData: {},
      schema: {
      name: {
        type: 'text',
        label: 'Enter Name',
        placeholder: 'Enter Name',
        required: true,
        info: true,
        character_count: 0
        },
      },
      action_buttons: {
        add_new_button: true,
        delete_button: true,
        active_button: true,
      },
      add_new_modal: {
        name: {
          type: 'text',
          label: 'Name',
          placeholder: '',
          required: true,
          info: false,
          character_count: 0
        },
      },
      side_panel: {
        groups: {
          type: 'multiselect',
          label: 'Groups',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          extra_label: 'Manage Groups'
        },
        subgroups: {
            type: 'multiselect',
            label: 'Sub-group',
            placeholder: '',
            required: false,
            info: false,
            character_count: 0,
            disabled: false,
            wrapper_class: '',
            options: [],
            extra_label: 'Manage Sub-Groups'
        },
        members: {
          type: 'list',
          label: 'Members',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          draggable: true
        },
      },
      form: {
        name: {
          type: 'text',
          label: 'Name',
          placeholder: '',
          required: true,
          info: true,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        role: {
          type: 'text',
          label: 'Role',
          placeholder: '',
          required: true,
          info: true,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        qualifications: {
          type: 'text',
          label: 'Qualifications',
          placeholder: '',
          required: true,
          info: true,
          character_count: 250,
          disabled: false,
          wrapper_class: ''
        },
        locations: {
          type: 'multiselect',
          label: 'Location(s)',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          options: [],
        },
        gender: {
          type: 'radio',
          label: 'Gender',
          placeholder: '',
          required: true,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          options: [
            {
              name: 'Male',
            },
            {
              name: 'Female',
            }
          ]
        },
        member_group: {
          type: 'multiselect',
          label: 'Group',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          options: [],
        },
        member_subgroup: {
          type: 'multiselect',
          label: 'Sub-Group',
          placeholder: '',
          required: false,
          info: false,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6',
          options: [],
        },
        // profile: {
        //     type: 'file',
        //     label: 'Profile',
        //     placeholder: '',
        //     required: true,
        //     info: true,
        //     character_count: 0,
        //     disabled: false,
        //     wrapper_class: ''
        // },
        description: {
            type: 'ckeditor',
            label: 'Description',
            placeholder: '',
            required: true,
            info: false,
            character_count: 2000,
            disabled: false,
            wrapper_class: ''
        },
      },
    },
  ]
};

const default_days = {
  mon: {
      am: 0,
      pm: 1
  },
  tue: {
      am: 0,
      pm: 1
  },
  wed: {
      am: 0,
      pm: 1
  },
  thu: {
      am: 0,
      pm: 1
  },
  fri: {
      am: 0,
      pm: 1
  },
  sat: {
      am: 0,
      pm: 1
  },
  sun: {
      am: 0,
      pm: 1
  }
}
export { schema, default_days };